import React from 'react'

import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Cell, ResponsiveContainer, Label, Tooltip } from 'recharts';

import { IChartProps } from '../../../interfaces/charts';

const BarChartComponent = (props: IChartProps) => {
    const { data, xLabel, yLabel, width, height, xTickAngle, xInterval } = props;

    return (
        <div className='immersion__chart_container'>
            <div className='immersion__chart_container__label__X'>
                <h5 className='immersion__chart_container__label__X__text'>{xLabel}</h5>
            </div>
            {/* <div className='immersion__chart_container__label__Y'>
                <h5 className='immersion__chart_container__label__Y__text'>{yLabel}</h5>
            </div> */}
            <ResponsiveContainer minWidth={width} height={height}>
                <BarChart
                    barCategoryGap="10%"
                    barGap={2}
                    data={data}
                    margin={{ top: 0, right: 0, left: 20, bottom: 45 }}
                >
                    <Tooltip />
                    <CartesianGrid vertical={false} stroke='#D8D8D8' strokeWidth={2} />
                    <XAxis
                        dataKey="name"
                        tickFormatter={(value) => value.length > 4 ? value.slice(0, 4) + '...' : value}
                        axisLine={false}
                        tickLine={false}
                        padding={{ left: 20, right: 20 }}
                        interval={xInterval ?? 2}
                        angle={xTickAngle ?? 0}
                        dy={xTickAngle ? 28 : 0}
                    />
                    <YAxis
                        axisLine={false}
                        tickLine={false}
                        tickFormatter={(value) => value >= 1000 ? `${value / 1000}k` : value}
                    >
                        <Label
                            value={yLabel}
                            position="insideBottomLeft"
                            angle={-90}
                            style={{ fill: '#000000', fontSize: '16px', fontWeight: '600' }}
                        />
                    </YAxis>
                    <Bar barSize={21} dataKey="value">
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.fill} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}

export default BarChartComponent;